var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:_vm.$style.main},_vm._l((_vm.columns),function(column,index){return _c('td',{key:index,class:_vm.isColumnService(column) ? _vm.$style.serviceTD : _vm.$style.defaultTD},[_vm._t(("expanded-row-cell-" + (index + 1)))],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }